import { render } from "./LeituraDetalhes.vue?vue&type=template&id=baf8abee&scoped=true"
import script from "./LeituraDetalhes.vue?vue&type=script&lang=js"
export * from "./LeituraDetalhes.vue?vue&type=script&lang=js"

import "./LeituraDetalhes.vue?vue&type=style&index=0&id=baf8abee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf8abee"]])

export default __exports__